import { useEffect, useState, useMemo } from "react"
import BaseTable from "./BaseTable"
import testResultService from "../../services/testResultService"
import { useParams } from "react-router-dom"
import { format} from "date-fns"

export default function HistoryTestResultTable () {



  const { test_id} = useParams()
  const [histories, setHisTories] = useState([])
  useEffect(() => {
    if (test_id)
    fetchMyTestResult(test_id)
  }, [test_id])
  const fetchMyTestResult = async () => {
    const response = await testResultService.getMyResultByTestId(test_id)
    setHisTories(response.data)
  }
  const data = useMemo(
    () => histories,
    [histories]
  )
  const columns = useMemo(
    () => [
      { header: "Điểm số", accessorKey: "score", cell: ({row}) => (
        <p>
          {Math.ceil(row.original.score)}
        </p>
      ) },
      { header: "Số câu đúng", accessorKey: "correct" },
      { header: "Ngày thực hiện", accessorKey: "taken_at", cell: ({row}) =>  (
        <span>{format(row.original.taken_at,"HH:mm - dd/MM/yyyy")}</span>
   ) },

    ],
    []
  );

  return (
    <BaseTable data={data} columns={columns} />
  )
}
